import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'reactstrap';
import config from '../../utils/util/config';

// Deployed environments are labelled by their deploy id (e.g. "uat", "sbox").
// Local keeps its per-port DEV n label, since every local stack shares deploy
// id "local".
const getEnvironmentLabel = (): string => {
  // @ts-expect-error
  if (config.isLocal()) {
    // @ts-expect-error
    return config.getEnvironmentName();
  }
  return process.env.REACT_APP_DEPLOY_ID ?? '';
};

const EnvironmentAlert: FC = () => {
  // @ts-expect-error
  if (config.isProduction() || config.isDemo()) {
    return null;
  }

  return (
    <Alert
      className="mb-0 rounded-0 text-center environment-alert"
      color="warning"
    >
      <FormattedMessage
        id="app.views.layout.environment_alert.text"
        defaultMessage="You are currently in the <strong>{environment}</strong> environment."
        description="Banner telling users which non-production environment (deploy id, e.g. uat or sbox) they are in"
        values={{
          strong: (chunks) => <strong>{chunks}</strong>,
          environment: getEnvironmentLabel(),
        }}
      />
    </Alert>
  );
};

export default EnvironmentAlert;
